import { DevSettings, devSettingsType } from '#settings/constants'
import { Toggle } from '#toggle/toggles'
import { createToggleProvider } from 'apprise-frontend-core/toggle/context'
import { useSettings } from 'apprise-frontend-streams/settings/api'


const [ToggleProvider, useBaseToggles] = createToggleProvider<Toggle>()

// the global policy, plus the toggles released to all from the Dev settings.
// logged users get the beta-tester policy (apprise-frontend-iam), guests the core default.
export const useToggles = () => {

    const base = useBaseToggles()

    // stored settings come back without module defaults: absent wherever Dev settings were saved before toggles.
    const { enabledFeatures = [] } = useSettings<DevSettings>(devSettingsType)

    return {

        isFeatureEnabled: (toggle: Toggle): boolean => enabledFeatures.includes(toggle) || base.isFeatureEnabled(toggle)
    }
}

export { ToggleProvider as Toggles }
